var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.isAutoRoutingMode) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-primary mt-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToShipmentAllocationRouting()
      }
    }
  }, [_vm._v("\n                Go to Shipment Allocation Routing\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.isAutoRoutingMode) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "name": "SrId",
      "placeholder": "Select SR",
      "selected-option": _vm.srItemObj
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.SrId),
      callback: function($$v) {
        _vm.SrId = $$v
      },
      expression: "SrId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SrId')),
      expression: "errors.has('SrId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SrId')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tripDayflag == 1),
      expression: "tripDayflag == 1"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please close existing trip from SR app.! ")]), _vm._v(" "), (_vm.tripTitle == 'Continue trip' && _vm.IsSRNeedTrip) ? _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v(" Trip Created Date : " + _vm._s(_vm.tripCreatedDate) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isShowCODAmount) ? _c('b-alert', {
    staticClass: "p-0 border-0 no-close-btn",
    attrs: {
      "show": _vm.dismissCountDownCOD,
      "dismissible": "",
      "fade": "",
      "variant": "transparent"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedCOD
    }
  }, [_c('span', {
    staticClass: "text-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.srCODPendingMsg)
    }
  })]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mt-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.TopReset && !_vm.isAutoRoutingMode),
      expression: "TopReset && !isAutoRoutingMode"
    }],
    staticClass: "btn btn-danger ml-2",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.IsSRNeedTrip) ? _c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.startTripFlag == false || _vm.tripDayflag == 1 || _vm.tripDateFlag == true || _vm.hideAllocateFlag == false
    },
    on: {
      "click": function($event) {
        return _vm.startTrip()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tripTitle))]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.SRSelectingloader
    },
    on: {
      "update:active": function($event) {
        _vm.SRSelectingloader = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.tripTitle == 'Start Trip' && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && tripTitle=='Start Trip' && IsSRNeedTrip"
    }],
    staticClass: "form-group row mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mr-1"
  }, [_c('b-input-group', [(!_vm.tripProvisionType || _vm.tripProvisionType == 'bike') ? _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('bike')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" Bike")]) : _vm._e(), _vm._v("  \n                "), (!_vm.tripProvisionType || _vm.tripProvisionType == 'vehicle') ? _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('vehicle')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Vehicle")]) : _vm._e(), _vm._v("  \n                "), (_vm.isSVCEnabledForAdhocVehicles && (!_vm.tripProvisionType || _vm.tripProvisionType == 'adhoc')) ? _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('adhoc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v("Adhoc Vehicle")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.vehicleType && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && vehicleType && IsSRNeedTrip"
    }],
    staticClass: "form-group row mt-2"
  }, [((_vm.vehicleType == 'bike' && _vm.srVehicleList.length == 0) || _vm.isVehicleReplaced == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleNo),
      expression: "vehicleNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "vehicleNo"
    },
    domProps: {
      "value": (_vm.vehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleNo),
      expression: "errVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / MHU 123 )")])], 1)], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srVehicleList,
      "selected-option": _vm.vehicleNoItemObj,
      "name": "vehicleNo",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "select": _vm.selectVehicleNo
    },
    model: {
      value: (_vm.vehicleNo),
      callback: function($$v) {
        _vm.vehicleNo = $$v
      },
      expression: "vehicleNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Open KM")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleOpenKM),
      expression: "vehicleOpenKM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Open KM",
      "name": "vehicleOpenKM"
    },
    domProps: {
      "value": (_vm.vehicleOpenKM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleOpenKM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleKm),
      expression: "errVehicleKm"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleKm))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vehicleType == 'bike' && _vm.srVehicleList.length > 0),
      expression: "vehicleType=='bike' && srVehicleList.length>0"
    }],
    staticClass: "col-md-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": function($event) {
        return _vm.isVehicleReplaceCheck($event)
      }
    },
    model: {
      value: (_vm.isVehicleReplacedCheck),
      callback: function($$v) {
        _vm.isVehicleReplacedCheck = $$v
      },
      expression: "isVehicleReplacedCheck"
    }
  }, [_vm._v("Is Vehicle Replaced?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.vehicleNo == '' || _vm.vehicleOpenKM == ''
    },
    on: {
      "click": function($event) {
        return _vm.startAllocation(true)
      }
    }
  }, [_vm._v("Start Allocation")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.allocationLoader
    },
    on: {
      "update:active": function($event) {
        _vm.allocationLoader = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideAllocateFlag && (_vm.startAllocationFlag || !_vm.IsSRNeedTrip)),
      expression: "hideAllocateFlag && (startAllocationFlag || !IsSRNeedTrip)"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentNo),
      expression: "shipmentNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shipmentNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter / Scan Shipment No",
      "autocomplete": "off",
      "name": "shipmentNo",
      "oncopy": "return false",
      "onpaste": "return false"
    },
    domProps: {
      "value": (_vm.shipmentNo)
    },
    on: {
      "drop": _vm.HandleDragOver,
      "keyup": _vm.handleShipmentNoKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowEbnVehicleNo),
      expression: "flagShowEbnVehicleNo"
    }],
    ref: "dummyShipInputBox",
    staticClass: "col-md-12 mt-2",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowEbnVehicleNo),
      expression: "flagShowEbnVehicleNo"
    }],
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ebnVehicleNo),
      expression: "ebnVehicleNo"
    }],
    ref: "ebnVehicleNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "ebnVehicleNo"
    },
    domProps: {
      "value": (_vm.ebnVehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ebnVehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errEbnVehicleNo),
      expression: "errEbnVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errEbnVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / MHU 123)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.shipmentNo == ''
    },
    on: {
      "click": function($event) {
        return _vm.Allocate()
      }
    }
  }, [_vm._v("Allocate")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.AllocateLoading
    },
    on: {
      "update:active": function($event) {
        _vm.AllocateLoading = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flagShowEbnVehicleNo),
      expression: "!flagShowEbnVehicleNo"
    }],
    ref: "dummyShipInputBox2",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  }), _vm._v(" "), (_vm.SrId !== '') ? _c('div', {
    staticClass: "form-group row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12 new-panel"
  }, [(_vm.hideAllocateFlag) ? _c('button', {
    staticClass: "btn btn-success ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isAllocation == false
    },
    on: {
      "click": function($event) {
        return _vm.CheckPDD()
      }
    }
  }, [_vm._v("Confirm Allocation\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger ml-2",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startAllocationFlag || !_vm.IsSRNeedTrip),
      expression: "startAllocationFlag || !IsSRNeedTrip"
    }],
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isConfirmLoad,
      "text": "Please wait confirm trip is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirmLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [(_vm.dismissCountDown > 0) ? _c('b-alert', {
    staticStyle: {
      "padding": "0%",
      "margin": "0%"
    },
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "danger"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v("\n                " + _vm._s(_vm.allocationErrorMsg)), _c('br'), _vm._v("\n                " + _vm._s(_vm.allocationMsgprexo) + "\n                "), (_vm.flagShowPreviousShipment) ? _c('i', {
    staticStyle: {
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ShowPendingShipments
    }
  }, [_c('br'), _vm._v(" Click here to view pending shipments")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dismissCountDownSuccess > 0) ? _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\n                " + _vm._s(_vm.allocationSuccessMsg)), _c('br'), _vm._v("\n                " + _vm._s(_vm.allocationMsgprexo) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('pending-Pods', {
    attrs: {
      "isPendingPodsLoader": _vm.isPodsLoader,
      "showShipmentList": _vm.PendingList
    },
    model: {
      value: (_vm.showShipmentModel),
      callback: function($$v) {
        _vm.showShipmentModel = $$v
      },
      expression: "showShipmentModel"
    }
  }), _vm._v(" "), _c('pending-group-id-shipment', {
    attrs: {
      "pendingGrouptErrorMsg": _vm.pendingGrouptErrorMsg,
      "showParentGroupIdShipmentList": _vm.showParentGroupIdShipmentList
    },
    model: {
      value: (_vm.showGroupIdShipmentModel),
      callback: function($$v) {
        _vm.showGroupIdShipmentModel = $$v
      },
      expression: "showGroupIdShipmentModel"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("SR Name : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.SrName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openKm),
      expression: "openKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "openKm"
    },
    domProps: {
      "value": (_vm.openKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorOpenKM),
      expression: "errorOpenKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorOpenKM))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeKm),
      expression: "closeKm"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Close KM",
      "name": "closeKm"
    },
    domProps: {
      "value": (_vm.closeKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closeKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCloseKM),
      expression: "errorCloseKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorCloseKM))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.closeKm == '' || _vm.openKm == ''
    },
    on: {
      "click": function($event) {
        return _vm.verifyTrip()
      }
    }
  }, [_vm._v("Verify/Modify")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeCloseTripModel()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.PrintShipmentModal),
      callback: function($$v) {
        _vm.PrintShipmentModal = $$v
      },
      expression: "PrintShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Print Shiment for Delivery")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePrintShipmentModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v("SR Name:")]), _vm._v("  "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(" " + _vm._s(_vm.SrName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Created Date:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "batchCreatedDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.batchCreatedDate),
      callback: function($$v) {
        _vm.batchCreatedDate = $$v
      },
      expression: "batchCreatedDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.batchCreatedDate == ''
    },
    on: {
      "click": function($event) {
        return _vm.GetShipmentPrintdetails()
      }
    }
  }, [_vm._v("Print Runsheet")]), _vm._v("    \n                          "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ResetPrintShipmentModal()
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowPrintTable),
      expression: "ShowPrintTable"
    }],
    staticClass: "col=md-12 mt-4"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadBatch,
      "text": "Please wait to batch table get open..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadBatch = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadPDF,
      "text": "Please wait.... PDF is being generating.!"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadPDF = $event
      }
    }
  }), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.PrintShipmentsColumns,
      "showShipmentsList": _vm.PrintShipmentsList,
      "BatchID": true,
      "ShipmentsNum": true,
      "EnableHyperLink": _vm.EnableHyperLink
    },
    on: {
      "printShipment": _vm.PrintShipment,
      "ExportCSV": _vm.exportCSVOfShippingIDS
    }
  })], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.NonAllocationRsn),
      callback: function($$v) {
        _vm.NonAllocationRsn = $$v
      },
      expression: "NonAllocationRsn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.BucketName))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.resultCount) + " Shipments with " + _vm._s(_vm.BucketName) + " Pending Allocation")])]), _vm._v(" "), (_vm.isCantallocate == true) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "margin-top": "3px"
    }
  }, [_vm._v("Please select the reason of non-allocation")])]) : _vm._e(), _vm._v(" "), (_vm.isCantallocate == true) ? _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Reason:")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    attrs: {
      "name": "Reason",
      "placeholder": "Select",
      "options": _vm.ReasonList,
      "selected-option": _vm.ReasonObj
    },
    on: {
      "select": _vm.selectReason
    },
    model: {
      value: (_vm.Reason),
      callback: function($$v) {
        _vm.Reason = $$v
      },
      expression: "Reason"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [(_vm.submitreasonbtn == true) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitNonAllocationRsn()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (_vm.cantallocatebtn == true) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cantAllocate()
      }
    }
  }, [_vm._v("Can't Allocate")]) : _vm._e(), _vm._v("     \n                        "), _c('b-button', {
    attrs: {
      "variant": _vm.buttonVariant
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelResaonBtnText))])], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.shipmentInfoFlag),
      callback: function($$v) {
        _vm.shipmentInfoFlag = $$v
      },
      expression: "shipmentInfoFlag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Information")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseshipmentInfoFlag()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("SR Tab")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P0:")]), _vm._v(" All escalations from SR’s prev attempted")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P1:")]), _vm._v(" All PDD breached + All Today’s PDD (SR’s prev attempted)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P2:")]), _vm._v(" PDD more than today (SR’s prev attempted & other than P0, P1)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Facility Tab")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P0:")]), _vm._v(" All escalations (inc attempted, fresh)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P1:")]), _vm._v(" All PDD breached + All Today’s PDD (attempted & fresh)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P2:")]), _vm._v(" PDD more than today (anything other than P0, P1 but eligible for allocation)")])])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 new-panel"
  }, [_c('Label', [_vm._v("Allocated Shipment (" + _vm._s(_vm.srAllocatedTotalCount) + ")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#151B31",
      "font-size": "18px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.loadAllocatedDetails('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Allocated Shipment List"
    }
  })]), _vm._v("  \n          "), _c('div', {
    staticClass: "scroll-container1"
  }, [_c('div', {
    staticClass: "scroll-content1"
  }, [_c('load-table-template', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "columns": _vm.AllocatedColumns,
      "showShipmentsList": _vm.AllocatedList,
      "RemoveAllocatedShipment": true,
      "Shipmentloader": _vm.AllocateTableLoader
    },
    on: {
      "RemoveShipment": _vm.RemoveShipment
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.srAllocatedTotalCount > 0 && _vm.srAllocatedTotalCount > _vm.srAllocatedPageLimit),
      expression: "srAllocatedTotalCount > 0 && srAllocatedTotalCount > srAllocatedPageLimit"
    }],
    ref: "paginate",
    attrs: {
      "page-count": _vm.srAllocatedPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.srAllocatedPagination,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 new-panel"
  }, [_c('label', {
    staticClass: "mt-4"
  }, [_vm._v("Smart Suggestions")]), _vm._v(" "), _c('div', {
    staticClass: "scroll-container1"
  }, [_c('div', {
    staticClass: "scroll-content1"
  }, [_c('b-tabs', {
    staticClass: "SmartAllocationtab"
  }, [_c('b-tab', {
    staticStyle: {
      "padding": "1%"
    },
    attrs: {
      "title": "Pre-Day Attempted"
    },
    on: {
      "click": function($event) {
        return _vm.PreviousDayShipmentList()
      }
    }
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.SuggestionColumns,
      "showShipmentsList": _vm.SuggestionList,
      "Shipmentloader": _vm.PDTableLoader
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    staticStyle: {
      "padding": "1%"
    },
    attrs: {
      "title": "Same Route Shipment"
    }
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.SameRouteColumns,
      "showShipmentsList": _vm.SameRouteList,
      "Shipmentloader": _vm.SMTableLoader
    }
  })], 1)], 1)], 1)])])])]), _vm._v(" "), (_vm.isShowPendingAllocatedList == true) ? _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('b-tabs', {
    staticClass: "UnAllocationtabs",
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": '<b>Pending</b> <br>  <small>' + _vm.pendingSrShipmentCount + ' (SR) | ' + _vm.pendingSVCShipmentCount + ' (Facility)</small>'
    },
    on: {
      "click": function($event) {
        return _vm.setDashboardCountTabName()
      }
    }
  }, [_c('div', {
    staticClass: "scroll-container1"
  }, [_c('div', {
    staticClass: "scroll-content1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.CountLoading
    },
    on: {
      "update:active": function($event) {
        _vm.CountLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSR
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsr', 'All')
      }
    }
  }, [_vm._v("SR (" + _vm._s(_vm.setCountSR) + ")")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSVC
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsvc', 'All')
      }
    }
  }, [_vm._v("Facility (" + _vm._s(_vm.setCountSVC) + ")")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.srBlockFlag == true) ? _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.srPriorities), function(priority) {
    return (_vm.getSRFlag('SR', priority)) ? _c('b-col', {
      key: priority,
      staticClass: "pb-2 p-1",
      attrs: {
        "lg": "4"
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": _vm.getSRVariant('SR', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelected('pendingsr', priority)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.formatPriorityLabel(priority)) + " (" + _vm._s(_vm.getSRCount('SR', priority)) + ")\n                        ")])], 1) : _vm._e()
  }), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2 pull-right",
    attrs: {
      "lg": "4"
    }
  }, [_c('a', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.shipmentInfo()
      }
    }
  }, [_c('b', [_c('u', [_vm._v("Info")])])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.svcBlockFlag == true) ? _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.svcPriorities), function(priority) {
    return (_vm.getSRFlag('SVC', priority)) ? _c('b-col', {
      key: priority,
      staticClass: "pb-2 p-1",
      attrs: {
        "lg": "4"
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": _vm.getSRVariant('SVC', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelected('pendingsvc', priority)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.formatPriorityLabel(priority)) + " (" + _vm._s(_vm.getSRCount('SVC', priority)) + ")\n                        ")])], 1) : _vm._e()
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-3"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.ClientLoader
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.clientList,
      "name": "client",
      "placeholder": "Select",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectClient
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Service Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.ServiceLoader
    }
  }, [_c('basic-select', {
    attrs: {
      "name": "ServiceType",
      "placeholder": "Select",
      "options": _vm.ServiceTypeList,
      "selected-option": _vm.ServiceTypeObj
    },
    on: {
      "select": _vm.selectServiceType
    },
    model: {
      value: (_vm.ServiceType),
      callback: function($$v) {
        _vm.ServiceType = $$v
      },
      expression: "ServiceType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mot")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    attrs: {
      "name": "MOT",
      "placeholder": "Select",
      "options": _vm.MOTList,
      "selected-option": _vm.MOTObj
    },
    on: {
      "select": _vm.selectMOT
    },
    model: {
      value: (_vm.MOT),
      callback: function($$v) {
        _vm.MOT = $$v
      },
      expression: "MOT"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Escalation")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.EscalationLoader
    }
  }, [_c('basic-select', {
    attrs: {
      "name": "Escalation",
      "placeholder": "Select",
      "options": _vm.EscalationList,
      "selected-option": _vm.EscalationObj
    },
    on: {
      "select": _vm.selectEscalation
    },
    model: {
      value: (_vm.Escalation),
      callback: function($$v) {
        _vm.Escalation = $$v
      },
      expression: "Escalation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Weight Group")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    attrs: {
      "name": "WeightGroup",
      "placeholder": "Select",
      "options": _vm.WeightGList,
      "selected-option": _vm.WeightGObj
    },
    on: {
      "select": _vm.selectWeightG
    },
    model: {
      value: (_vm.WeightGroup),
      callback: function($$v) {
        _vm.WeightGroup = $$v
      },
      expression: "WeightGroup"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Cluster Id")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    attrs: {
      "name": "ClusterId",
      "placeholder": "Select",
      "options": _vm.ClusterList,
      "selected-option": _vm.ClusterObj
    },
    on: {
      "select": _vm.selectCluster
    },
    model: {
      value: (_vm.ClusterId),
      callback: function($$v) {
        _vm.ClusterId = $$v
      },
      expression: "ClusterId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Enter AWB's: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccAWBNumbers),
      expression: "AccAWBNumbers"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Awb no",
      "name": "AccAWBNumbers"
    },
    domProps: {
      "value": (_vm.AccAWBNumbers)
    },
    on: {
      "keypress": _vm.OnlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AccAWBNumbers = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.ResetLoader
    },
    on: {
      "update:active": function($event) {
        _vm.ResetLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.client == '' && _vm.ServiceType == '' && _vm.WeightGroup == '' && _vm.AccAWBNumbers == '' && _vm.Escalation == '' && _vm.ClusterId == '' && _vm.MOT == ''
    },
    on: {
      "click": function($event) {
        return _vm.filterPendingList()
      }
    }
  }, [_vm._v("Search")]), _vm._v("   \n                      "), _c('button', {
    staticClass: "btn btn-danger ml-2",
    on: {
      "click": function($event) {
        return _vm.RightTabReset()
      }
    }
  }, [_vm._v("Reset")])])], 1), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.UnallocatedColumns,
      "showShipmentsList": _vm.showUnallocatedList,
      "Shipmentloader": _vm.UATableLoader
    }
  })], 1)])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": '<b>Allocated</b> <br>  <small>' + _vm.allocateSrShipmentCount + ' (SR) | ' + _vm.allocateSVCShipmentCount + ' (Facility)</small>'
    },
    on: {
      "click": function($event) {
        return _vm.setDashboardCountTabName()
      }
    }
  }, [_c('div', {
    staticClass: "scroll-container1"
  }, [_c('div', {
    staticClass: "scroll-content1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.CountLoading
    },
    on: {
      "update:active": function($event) {
        _vm.CountLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSRAllocated
    },
    on: {
      "click": function($event) {
        return _vm.changeSelectedAllocation('allocatedsr', 'All')
      }
    }
  }, [_vm._v("SRAllocated (" + _vm._s(_vm.setCountSRAllocated) + ")")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSVCAllocated
    },
    on: {
      "click": function($event) {
        return _vm.changeSelectedAllocation('allocatedsvc', 'All')
      }
    }
  }, [_vm._v("Facility (" + _vm._s(_vm.setCountSVCAllocated) + ")")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.srAllocatedBlockFlag == true) ? _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.srAllocatedPriorities), function(priority) {
    return (_vm.getSRAllocatedFlag('SR', priority)) ? _c('b-col', {
      key: priority,
      staticClass: "pb-2 p-1",
      attrs: {
        "lg": "4"
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": _vm.getSRAllocatedVariant('SR', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelectedAllocation('allocatedsr', priority)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.formatPriorityLabel(priority)) + " (" + _vm._s(_vm.getSRAllocatedCount('SR', priority)) + ")\n                        ")])], 1) : _vm._e()
  }), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2 pull-right",
    attrs: {
      "lg": "4"
    }
  }, [_c('a', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.shipmentInfo()
      }
    }
  }, [_c('b', [_c('u', [_vm._v("Info")])])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.svcAllocatedBlockFlag == true) ? _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.svcAllocatedPriorities), function(priority) {
    return (_vm.getSRAllocatedFlag('SVC', priority)) ? _c('b-col', {
      key: priority,
      staticClass: "pb-2 p-1",
      attrs: {
        "lg": "4"
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": _vm.getSRAllocatedVariant('SVC', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelectedAllocation('allocatedsvc', priority)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.formatPriorityLabel(priority)) + " (" + _vm._s(_vm.getSRAllocatedCount('SVC', priority)) + ")\n                        ")])], 1) : _vm._e()
  }), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2 pull-right",
    attrs: {
      "lg": "4"
    }
  }, [_c('a', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.shipmentInfo()
      }
    }
  }, [_c('b', [_c('u', [_vm._v("Info")])])])])], 2)]) : _vm._e(), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.AllocatedColumns,
      "showShipmentsList": _vm.showAllocatedShipmentsList,
      "Shipmentloader": _vm.HUbAllocatedTableLoader
    }
  })], 1)])])], 1)], 1)])]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c832c93","hasScoped":true}!./src/views/components/newallocationpagev2/forwardallocation/forwardallocation.html
// module id = 1531
// module chunks = 1